<template>
<div id="apptable" v-cloak>

    <b-card header="Prenotazioni Prodotti Evento - Storico" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
        <div class="text-left">

            <div class="my-1 row">
                <div class="col-md-3">
                    <label for="datainizio">Data inizio:</label>
                    <b-form-input v-model="datainizio" id="datainizio" type="date" />
                </div>
                <div class="col-md-3">
                    <label for="datafine">Data fine:</label>
                    <b-form-input v-model="datafine" id="datafine" type="date" />
                </div>
            </div>

            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="filter" placeholder="Cerca..." />
                </div>
                <div class="col-md-9 text-right">
                    <b-button style="margin:1px 0px 1px 2px;" size="md" variant="outline-secondary" @click.stop="exportCSV()">
                        Esporta CSV
                    </b-button>
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive v-show="showtable" id="main-table" striped hover show-empty :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" empty-text="Non sono stati trovati record da visualizzare" empty-filtered-text="Non sono stati trovati record corrispondenti alla tua richiesta">
                <template slot="payload" scope="row"> <b-link @click="showPayload(row.item)">{{row.value.length > 10 ? row.value.substr(0, 9) + "..." : row.value}}</b-link></template>
          
            </b-table>

            <div class="row my-1">
                <div class="col-md-8 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </div>
                <div class="col-md-4 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="pageOptions" v-model="perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>

        <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>

    </b-card>

    <b-modal v-model="modalPayload.show" :title="modalPayload.title">
        <div style="max-height: 300px; overflow-y: auto;">
            <pre>{{modalPayload.payload}}</pre>
        </div>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="modalPayload.show=false">
                Chiudi
            </b-btn>
        </div>
    </b-modal>

</div>

</template>

<script>
import moment from 'moment'

import {
    NAMESPACE
} from '../config.js'

import {
    PrenotazioniPEStorico
} from '../classes.js'

import {
    ctrlVismenu,
} from '../util.js'

export default {
    name: 'apptable',
    data: function () {
        return {            
            modalPayload: {
                title: '',
                payload: '',
                show: false,
            },
            items: [],
            namespace: NAMESPACE,
            fields: {
                id: {
                    label: '#',
                    sortable: true
                },
                guid_richiesta: {
                    label: '# Richiesta',
                    sortable: true
                },
                tipoVis: {
                    label: 'Tipo Richiesta',
                    sortable: true
                },
                payload: {
                    label: 'Payload',
                    sortable: true
                },
                id_socio: {
                    label: '# Socio',
                    sortable: true
                },
                accountsocio: {
                    label: 'Account Socio',
                    sortable: true
                },
                cognomesocio: {
                    label: 'Cognome Socio',
                    sortable: true
                },
                nomesocio: {
                    label: 'Nome Socio',
                    sortable: true
                },
                id_evento: {
                    label: '# Evento',
                    sortable: true
                },
                id_apievento: {
                    label: '# Evento sis. centrale',
                    sortable: true
                },
                titoloevento: {
                    label: 'Titolo Evento',
                    sortable: true
                },
                datains: {
                    label: 'Data inserimento',
                    sortable: true
                },
                uteins: {
                    label: 'Utente inserimento',
                    sortable: true
                },
            },
            currentPage: 1,
            perPage: 10,
            pageOptions: [{
                text: 10,
                value: 10
            }, {
                text: 25,
                value: 25
            }, {
                text: 50,
                value: 50
            }],
            sortBy: null,
            sortDesc: false,
            filter: this.$route.params.filter || null,
            totalRowsFilter: null,
            error: '',
            showerror: false,
            showtable: false,
            datainizio: this.$route.params.datainizio || moment().subtract(30, 'days').format('YYYY-MM-DD'),
            datafine: this.$route.params.datafine || moment().format('YYYY-MM-DD'),
            id_evento: this.$route.params.id_evento || null,
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.totalRowsFilter || this.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.totalRowsFilter = newValue;
            }
        }
    },
    watch: {
        filter: function (newValue, oldValue) {
            this.datainizio = (this.datainizio == '' ? null : this.datainizio)
            this.datafine = (this.datafine == '' ? null : this.datafine)
            if((this.filter || '') !== ''){
                this.$router.replace({
                    path: `/app/prenotazionipestorico/id_evento/${this.id_evento}/${this.filter}/filter/${this.filter}/datainizio/${this.datainizio}/datafine/${this.datafine}`
                });
            }
            else{
                this.$router.replace({
                    path: `/app/prenotazionipestorico/id_evento/${this.id_evento}/datainizio/${this.datainizio}/datafine/${this.datafine}`
                });
            }

        },
        datainizio: function (newValue, oldValue) {
            this.datainizio = (this.datainizio == '' ? null : this.datainizio)
            this.datafine = (this.datafine == '' ? null : this.datafine)
            if((this.filter || '') !== ''){
                this.$router.replace({
                    path: `/app/prenotazionipestorico/id_evento/${this.id_evento}/datainizio/${this.datainizio}/datafine/${this.datafine}`
                });
            }
            else{
                this.$router.replace({
                    path: `/app/prenotazionipestorico/id_evento/${this.id_evento}/datainizio/${this.datainizio}/datafine/${this.datafine}`
                });
            }
            this.refreshData();
        },
        datafine: function (newValue, oldValue) {
            this.datainizio = (this.datainizio == '' ? null : this.datainizio)
            this.datafine = (this.datafine == '' ? null : this.datafine)
            if((this.filter || '') !== ''){
                this.$router.replace({
                    path: `/app/prenotazionipestorico/id_evento/${this.id_evento}/filter/${this.filter}/datainizio/${this.datainizio}/datafine/${this.datafine}`
                });
            }
            else{
                this.$router.replace({
                    path: `/app/prenotazionipestorico/id_evento/${this.id_evento}/datainizio/${this.datainizio}/datafine/${this.datafine}`
                });
            }
            this.refreshData();
        }
    },
    filters: {
        formatDate: function (value) {
            if (!value) return '';
            return moment(String(value)).format('DD/MM/YYYY')
        }
    },
    methods: {
        showPayload(row){
            let aux = row.payload
            try{
                if(aux){
                    aux = JSON.stringify(JSON.parse(aux), null, 2)
                }
            }
            catch(e){null}
            this.modalPayload.payload = aux
            this.modalPayload.title = "Payload #" + row.id
            this.modalPayload.show = true
        },
        exportCSV() {

            if (this.items.length > 0) {
                var str = '"#";"# Richiesta";"Tipo Richiesta";"Payload";"# Socio";"Account Socio";"Cognome Socio";"Nome Socio";"# Evento";"# Evento sis. centrale";"Titolo Evento";"Data inserimento";"Utente inserimento"\r\n';
                for (var i = 0; i < this.items.length; i++) {
                    str += '"' + this.items[i].id + '"' + ";";
                    str += '"' + this.items[i].guid_richiesta.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + this.items[i].tipoVis.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + this.items[i].payload.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + this.items[i].id_socio + '"' + ";";
                    str += '"' + this.items[i].accountsocio.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + this.items[i].cognomesocio.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + this.items[i].nomesocio.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + this.items[i].id_evento + '"' + ";";
                    str += '"' + this.items[i].id_apievento + '"' + ";";
                    str += '"' + this.items[i].titoloevento.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + this.items[i].datains + '"' + ";";
                    str += '"' + this.items[i].uteins.replace(/\"/g, "\"\"") + '"' + "\r\n";
                }

                var a = document.createElement('a');
                var blob = new Blob([str], {
                    'type': 'application\/octet-stream'
                });

                a.href = window.URL.createObjectURL(blob);
                a.download = 'prenotazioni_pe_storico_' + moment(String(new Date())).format('YYYYMMDD_HHmmss') + '.csv';
                document.body.appendChild(a);
                a.click();
                setTimeout(function () {
                    document.body.removeChild(a);
                }, 100);

            }

        },      
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        refreshData() {

            var token = localStorage.getItem('token');
            this.axios.get(NAMESPACE + `rest/prenotazionipestorico/datainizio/${this.datainizio}/datafine/${this.datafine}/id_evento/${this.id_evento}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        this.items = response.data.message; 

                        var pe = new PrenotazioniPEStorico();

                        for (var i = 0; i < this.items.length; i++) {
                            this.items[i].tipoVis = pe.getTipoByFlag(this.items[i].tipo);
                        }

                        this.showtable = true;

                    } else {
                        throw new Error(response.data.message);
                    }

                } catch (e) {
                    this.showerror = true;
                    this.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                this.showerror = true;
                this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });



        },

    },
    created: function () {

        if(!ctrlVismenu("E")){
            this.$router.replace('/accessdenied');
            return;
        }



        this.refreshData();

    }
}
</script>
